module.exports = __webpack_public_path__ + "img/3.a4761a39.png";